import { schema } from "normalizr";

export const cryptocurrencySchema = new schema.Entity("cryptocurrency", {});
export const arrayOfCryptocurrencySchemas = new schema.Array(
  cryptocurrencySchema
);
